import { Card } from "./PriceCard/PriceCard";

export const priceData: Card[] = [
  {
    title: 'Однокомнатная',
    price: '119.92 zł',
    text: 'В стоимость входит уборка комнаты, кухни, ванной комнаты и коридора',
  },
  {
    title: 'Двухкомнатная',
    price: '143.92 zł',
    text: 'В стоимость входит уборка комнаты, кухни, ванной комнаты и коридора',
  },
  {
    title: 'Трехкомнатная',
    price: '167.92 zł',
    text: 'В стоимость входит уборка комнаты, кухни, ванной комнаты и коридора',
  }
]